

import TopBar from "../../../components/TopBar";

import fileImageIcon from "../../../assets/images/upload.svg"
import { useState } from "react";
import axiosInstance from "../../../api/axiosInstance";

const ImportProduct = () => {

    const [isImporting, setIsImporting] = useState(false);
    const [importDataList, setImportDataList] = useState([])
    const [isDragging, setIsDragging] = useState(false);

    const uploadFile = async (file) => {
        try {
            if (!file) return;

            setIsImporting(true);

            const formData = new FormData();
            formData.append("file", file);

            const response = await axiosInstance.post(
                "/products/import",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response?.data?.success) {
                setImportDataList(response?.data?.data || []);
            } else {
                console.log(response?.data?.message || "Import failed");
            }
        } catch (error) {
            console.log({ error });
        } finally {
            setIsImporting(false);
        }
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        uploadFile(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();

        setIsDragging(false);

        const file = e.dataTransfer.files[0];

        if (file && file.type === "text/csv") {
            uploadFile(file);
        } else {
            console.log("Please upload a CSV file");
        }
    };

    return (
        <div className={`products-import`}>
            <TopBar />

            <section className='dashboard productImport'>
                <div className="container">
                    <div className="newpageLeftRow textBlock ulpoadImageBlock">
                        <div className="fileUploadBox">
                            <input
                                type="file"
                                id="product-file"
                                accept=".csv"
                                onChange={handleFileUpload}
                                style={{ display: 'none' }}
                            />
                            <div
                                className={`uploadFileBlock ${isDragging ? "drag-active" : ""}`}
                                onClick={() => document.getElementById("product-file").click()}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}>
                                <div className="featureImgMiddleContent">
                                    {
                                        isImporting ?
                                            <div className='progressWrap'>
                                                <div className="progress">
                                                    <div className="color"></div>
                                                </div>
                                            </div> :
                                            <>
                                                <img className="fileUploadCover_Img" src={fileImageIcon} alt="FeaturedImage" />

                                                <p className="newPageImageUploadText">
                                                    <span>Click to upload</span> or drag and drop{" "}
                                                    <br />
                                                    <>
                                                        <b>CSV file</b>
                                                    </>
                                                </p>

                                            </>
                                    }
                                </div>
                            </div>
                            <div className="import-table-wrapper">
                                <table className="import-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Product Title</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {importDataList?.length > 0 ? (
                                            importDataList.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>

                                                    <td className="title-cell">
                                                        {item?.title || "-"}
                                                    </td>

                                                    <td>
                                                        <span
                                                            className={`status-badge ${item?.status === "done"
                                                                ? "done"
                                                                : "fail"
                                                                }`}
                                                        >
                                                            {item?.status || "pending"}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="empty-state">
                                                    No import data found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ImportProduct;